var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNoteIcon = function SvgNoteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8H12.5M7.5 10.5H12.5M7.5 13H10M16.8203 13H12.5V17.3203M12.2422 17.375H3.75C3.58424 17.375 3.42527 17.3092 3.30806 17.1919C3.19085 17.0747 3.125 16.9158 3.125 16.75V4.25C3.125 4.08424 3.19085 3.92527 3.30806 3.80806C3.42527 3.69085 3.58424 3.625 3.75 3.625H16.25C16.4158 3.625 16.5747 3.69085 16.6919 3.80806C16.8092 3.92527 16.875 4.08424 16.875 4.25V12.7422C16.8753 12.8233 16.8596 12.9038 16.8287 12.9788C16.7979 13.0539 16.7526 13.1222 16.6953 13.1797L12.6797 17.1953C12.6222 17.2526 12.5539 17.2979 12.4788 17.3287C12.4038 17.3596 12.3233 17.3753 12.2422 17.375Z",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgNoteIcon;